export type SubnavParam = 'drafts' | 'all-campaigns' | 'lead-engage';
export type TypeParam = 'text' | 'email' | 'leads' | 'campaigns';
export type ViewParam = 'editor' | 'compose' | 'templates' | 'new-email';

export const isValidSubNav = (subNav: string): subNav is SubnavParam => {
  return (['drafts', 'all-campaigns', 'lead-engage'] satisfies SubnavParam[]).includes(subNav as SubnavParam);
};

export const isValidType = (type: string): type is TypeParam => {
  return (['text', 'email', 'leads', 'campaigns'] satisfies TypeParam[]).includes(type as TypeParam);
};

export const isValidView = (view: string): view is ViewParam => {
  return (['editor', 'compose', 'templates', 'new-email'] satisfies ViewParam[]).includes(view as ViewParam);
};

export const fromSearchFlag = (value: unknown): true | undefined => {
  return value === 'true' || value === true ? true : undefined;
};

export const fromSearchParam = (value: unknown): string | undefined => {
  return typeof value === 'string' && value !== '' ? value : undefined;
};
